"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Search_Close: "Close search results",
                Search_SelectNext: "Select next search result",
                Search_SelectPrev: "Select previous search result",
            }
        });
        var CombinedSearchField = /** @class */ (function (_super) {
            __extends(CombinedSearchField, _super);
            function CombinedSearchField() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            CombinedSearchField.prototype.init = function (data, element) {
                _super.prototype.init.call(this, data, element);
                this.ResultList = $dyn.observableArray([]);
            };
            CombinedSearchField.prototype.Placeholder = function () {
                return "";
            };
            CombinedSearchField.prototype.keyDown = function (evt) {
                $dyn.util.handleShortcuts(this, evt);
            };
            CombinedSearchField.prototype.focusOut = function (evt) {
                this.SearchField().Value("");
                $(this.element).removeClass("combinedSearch-field-no-placeHolder");
            };
            CombinedSearchField.prototype.nextItem = function () {
                var nextIndex = $dyn.value(this.SelectedIndex) + 1;
                var items = $dyn.value(this.ResultList);
                if (items && nextIndex >= items.length) {
                    nextIndex = 0;
                }
                this.SelectedIndex(nextIndex);
                this.scrollSelectedResultIntoView(nextIndex);
            };
            CombinedSearchField.prototype.previousItem = function () {
                var previousIndex = $dyn.value(this.SelectedIndex) - 1;
                var items = $dyn.value(this.ResultList);
                if (previousIndex < 0 && items) {
                    previousIndex = items.length - 1;
                }
                this.SelectedIndex(previousIndex);
                this.scrollSelectedResultIntoView(previousIndex);
            };
            CombinedSearchField.prototype.openResultPicker = function () {
                this.SelectedIndex(0);
                this.ShowResultPicker(true);
            };
            CombinedSearchField.prototype.closeResultPicker = function (evt) {
                this.ShowResultPicker(false);
                // If closing for any other reason besides pressing esc, set focus to last active element in the main form
                if (!(evt && evt.which === $dyn.ui.KeyCodes.esc)) {
                    var rootForm = $dyn.shell.getCurrentRootForm();
                    var rootFormContext = $dyn.context(rootForm);
                    if (rootFormContext) {
                        var newActive = rootFormContext.ActiveElementInMainFormContainer();
                        if (newActive) {
                            rootFormContext.form_setFocus(newActive, rootFormContext.ActiveElement());
                        }
                    }
                }
            };
            CombinedSearchField.prototype.scrollSelectedResultIntoView = function (index) {
                var $resultsFlyout = $(document).find(".searchResultsFlyout");
                if ($resultsFlyout.length) {
                    var $selectedElement = $resultsFlyout.find(".flyout-menuItem").eq(index);
                    if ($selectedElement.length) {
                        $selectedElement[0].scrollIntoView(false);
                    }
                }
            };
            CombinedSearchField.prototype.SearchField = function () {
                if (!this._searchField) {
                    this._searchField = $dyn.context(this.SearchFieldElement());
                }
                return this._searchField;
            };
            CombinedSearchField.prototype.SearchFieldElement = function () {
                if (!this._searchFieldElement) {
                    this._searchFieldElement = $(this.element).find(".combinedSearch-searchField")[0];
                }
                return this._searchFieldElement;
            };
            return CombinedSearchField;
        }($dyn.ui.Control));
        controls.CombinedSearchField = CombinedSearchField;
        CombinedSearchField.prototype.CanAcquireFocus = false;
        // tslint:disable-next-line:no-string-literal
        CombinedSearchField.prototype["ProcessResults"] = true;
        $dyn.ui.addObservablePropertiesToPrototype(CombinedSearchField.prototype, {
            SelectedIndex: 0,
            ShowResultPicker: false,
            Visible: true,
        });
        // tslint:disable:object-literal-sort-keys
        var searchFieldShortcuts = {
            DownArrow: {
                Keys: { keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function () {
                    if ($dyn.value(this.ShowResultPicker)) {
                        this.ProcessResults = false;
                        this.nextItem();
                    }
                    else {
                        // So we do not stop propagation/prevent default
                        return false;
                    }
                },
                RecordTelemetry: false,
                ShowToUser: function () { return $dyn.value(this.ShowResultPicker); },
                Description: $dyn.label("Search_SelectNext")
            },
            UpArrow: {
                Keys: { keyCode: $dyn.ui.KeyCodes.upArrow },
                Handler: function () {
                    if ($dyn.value(this.ShowResultPicker)) {
                        this.ProcessResults = false;
                        this.previousItem();
                    }
                    else {
                        // So we do not stop propagation/prevent default
                        return false;
                    }
                },
                RecordTelemetry: false,
                ShowToUser: function () { return $dyn.value(this.ShowResultPicker); },
                Description: $dyn.label("Search_SelectPrev")
            },
            Esc: {
                Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                Handler: function (evt) {
                    if ($dyn.value(this.ShowResultPicker)) {
                        this.closeResultPicker(evt);
                        return true;
                    }
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: function () { return $dyn.value(this.ShowResultPicker); },
                Description: $dyn.label("Search_Close")
            }
        };
        CombinedSearchField.prototype.Shortcuts = $dyn.extendPrototype(CombinedSearchField.prototype.Shortcuts, searchFieldShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=CombinedSearchField.js.map
